import { createSelectorCreator, defaultMemoize } from 'reselect';
import { is, Map } from 'immutable';

const createImmutableSelector = createSelectorCreator(defaultMemoize, is);

const getHomeId = (state, homeId) => homeId;
const profileSelector = state => state.data.user;
const searchCityUrlSelector = state => state.data.searchCityUrl;
const clientInterfaceSelector = state => state.environments.fhe.config.get('clientInterface');

const homesSelector = state => state.environments.fhe.data.Homes.get('list');
const boxesSelector = state => state.environments.fhe.data.Boxes.get('list');
const brandsSelector = state => state.environments.fhe.data.Brands.get('list');
const installersSelector = state => state.environments.fhe.data.Installers.get('list');
const usersSelector = state => state.environments.fhe.data.Users.get('list');
const productsSelector = state => state.environments.fhe.data.Products.get('list');

const historyActionsSelector = state => state.environments.fhe.data.Homes.get('historyActions');
const prefixFheCenterSelector = state => state.environments.fhe.data.Boxes.get('prefixFheCenter');

const homeInitializedSelector = state => state.environments.fhe.data.Homes.get('initialized');
const userInitializedSelector = state => state.environments.fhe.data.Users.get('initialized');
const installersInitializedSelector = state => state.environments.fhe.data.Installers.get('initialized');
const getCodeEnv = state => state.data.configEnvs.getIn(['fhe', 'code'], null);

const homeByHomeIdSelector = (state, homeId) => state.environments.fhe.data.Homes.getIn(['list', homeId], new Map());
const getBoxByHomeId = (boxes, homeId) => {
    let homeBox = new Map();
    boxes.map(Box => {
        if (Box.get('homeId') === parseInt(homeId) && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1) homeBox = Box;
    });
    return homeBox;
};
const getUsersByHomeId = (users, homeId) => {
    return users.filter(user => user.getIn(['homeId'], '').toString() === homeId);
};
const productsByHomeIdSelector = (products, homeId) => {
    return products.filter(Product => {
        return Product.getIn(['homeId'], '').toString() === homeId;
    });
};
const mergeBoxesInHomes = (Homes, Boxes) => {
    Boxes.map(Box => {
        if (Box.get('homeId') !== null && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1 && Homes.has(Box.get('homeId').toString())) {
            Homes = Homes.mergeIn([Box.get('homeId').toString()], Box);
        }
    });
    return Homes;
};
const getBoxesArray = Boxes => {
    let boxesArray = [];
    Boxes.map((Box, key) => {
        if (Box.get('homeId') === null || ['nouvelle', 'inactive'].indexOf(Box.get('boxState')) !== -1)
            boxesArray.push({ mac: key, id: Box.get('boxId') });
    });

    return boxesArray;
};

export default {
    getHomesWithBoxes: createImmutableSelector([homesSelector, boxesSelector], mergeBoxesInHomes),
    getBoxByHomeId: createImmutableSelector([boxesSelector, getHomeId], getBoxByHomeId),
    getUsersByHomeId: createImmutableSelector([usersSelector, getHomeId], getUsersByHomeId),
    getProductsByHomeId: createImmutableSelector([productsSelector, getHomeId], productsByHomeIdSelector),
    getBoxesArray: createImmutableSelector([boxesSelector], getBoxesArray),
    getHomeByHomeId: homeByHomeIdSelector,
    getProfile: profileSelector,
    getInstallers: installersSelector,
    getBrands: brandsSelector,
    getHistoryActions: historyActionsSelector,
    getClientInterface: clientInterfaceSelector,
    getSearchCityUrl: searchCityUrlSelector,
    getPrefixFheCenter: prefixFheCenterSelector,
    getHomesInitialized: homeInitializedSelector,
    getInstallersInitialized: installersInitializedSelector,
    getCodeEnv: getCodeEnv
};



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/selectors.js